import React from 'react';
import { Card, CardContent } from '../ui/card';

export const EVVSummaryCards = ({ summary, filterStatus, onFilterChange }) => {
  const primary = [
    { label: 'Total', value: summary.total || 0, color: 'text-slate-700', filter: 'all' },
    { label: 'Pending Approval', value: summary.pending_approval || 0, color: 'text-amber-700', filter: 'pending_approval' },
    { label: 'Approved', value: summary.approved || 0, color: 'text-teal-700', filter: 'approved' },
    { label: 'Accepted', value: summary.accepted || 0, color: 'text-emerald-700', filter: 'accepted' },
    { label: 'Failed', value: summary.failed || 0, color: 'text-red-700', filter: 'failed' },
  ];
  const secondary = [
    { label: 'Draft', value: summary.draft || 0, color: 'text-slate-500', filter: 'draft' },
    { label: 'Rejected', value: summary.rejected_approval || 0, color: 'text-rose-600', filter: 'rejected_approval' },
    { label: 'Submitted', value: summary.submitted || 0, color: 'text-sky-700', filter: 'submitted' },
    { label: 'Corrected', value: summary.corrected || 0, color: 'text-violet-700', filter: 'corrected' },
  ];

  const renderCard = (card, padded = true) => (
    <Card
      key={card.label}
      className={`border-slate-200 cursor-pointer hover:border-indigo-300 transition-colors ${
        filterStatus === card.filter ? 'ring-2 ring-indigo-200' : ''
      }`}
      onClick={() => onFilterChange(card.filter)}
      data-testid={`summary-card-${card.filter}`}
    >
      <CardContent className={padded ? 'pt-4 pb-3 px-4' : 'pt-3 pb-2 px-4'}>
        <p className="text-xs text-slate-500 uppercase tracking-wide">{card.label}</p>
        <p className={`${padded ? 'text-2xl' : 'text-xl'} font-bold ${padded ? 'mt-1' : 'mt-0.5'} ${card.color}`}>
          {card.value}
        </p>
      </CardContent>
    </Card>
  );

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {primary.map((c) => renderCard(c, true))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {secondary.map((c) => renderCard(c, false))}
      </div>
    </>
  );
};
